import React from "react";
import { BarChart } from "@mui/x-charts";
import { useGetUsersByGovQuery } from "../../Apis/authApi";
import { GOVERNORATES } from "../../Utility/Gov";
import { CircularProgress, Box, Typography,Card, CardHeader, CardContent } from "@mui/material";

// 1. Define local interfaces to satisfy the compiler
interface Governorate {
  id: number;
  displayName: string;
  shortCut: string;
}



export default function GovChart() {
  // Use the interface in the hook to type 'reportData'
  const { data: reportData, isLoading, isError } = useGetUsersByGovQuery();

  if (isLoading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
        <CircularProgress />
      </Box>
    );

  if (isError)
    return <Typography color="error">Error loading report data.</Typography>;

  
  const chartData = (reportData ?? [])
    .map((item) => {
      const govInfo = (GOVERNORATES as Governorate[]).find((g) => g.id === item.govId);
      return {
        label: govInfo ? govInfo.shortCut : `ID: ${item.govId}`,
        value: item.count,
      };
    })
    .sort((a, b) => b.value - a.value);

  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        overflow: "hidden",
      }}
    >
      <CardHeader
        sx={{ background: "#f8f8f8" }}
        title={
          <Typography
            variant="h6"
            sx={{ color: "#eb3c96", fontWeight: "bold", m: 0 }}
          >
            User Distribution by Governorate
          </Typography>
        }
      />
      <CardContent>
        <Box
          sx={{
            width: "100%",
            p: 2,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <Typography
            variant="h5"
            sx={{ mb: 3, fontWeight: "bold" }}
          ></Typography>

          {/* 3. Render Chart only if data exists to avoid empty state errors */}
          {chartData.length > 0 ? (
            <BarChart
              dataset={chartData}
              hideLegend={true}              
              yAxis={[
                {
                  //scaleType: "band",
                  dataKey: "label",
                  
                  width:100,
                  tickLabelStyle: {
                    fontSize: 14,
                    fontWeight: "medium",
                  },
                },
              ]}
              xAxis={[
                {
                  label: "Total Users",
                },
              ]}
              series={[
                {
                  dataKey: "value",
                  label: "Users",
                  valueFormatter: (value: number | null) =>
                    `${value ?? 0} Users`,
                  color: "#512384",
                },
              ]}
              layout="horizontal"
              height={300}
            />
          ) : (
            <Typography>No data available for the report.</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}